/*
 * @Author: CaoJianBo
 * @Date: 2023-07-11 15:16:55
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-07-19 16:18:16
 * @FilePath: \fe-crm\src\api\product-service.js
 */
import { BaseService } from './base-service';

class ProductService extends BaseService {
  /**
   * @description: 价格列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getProductPrice(data) {
    return this.request({
      method: 'post',
      url: `/price/list`,
      data
    });
  }

  /**
   *  产品价格中的下拉列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  getEnumList(data) {
    return this.request({
      method: 'get',
      url: `/product/getEnumList`,
      data
    });
  }
  /**
   *  价格列表新增
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  addPrice(data) {
    return this.request({
      method: 'post',
      url: `/price/add`,
      data
    });
  }
  /**
   *  价格列表编辑
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  editPrice(data) {
    return this.request({
      method: 'post',
      url: `/price/update`,
      data
    });
  }
  /**
   *  价格列表删除
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  deletePrice(data) {
    return this.request({
      method: 'post',
      url: `/price/delete`,
      data
    });
  }
}

export const productService = new ProductService();
